import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ProductDetailInfosInput, ProductLineEmitter } from '../product-detail-infos-input/product-detail-infos-input';
import { Product } from '@app/core/interfaces';
import { TabStates } from '../product-detail/product-detail';
import { BaseComponent } from '@app/core/bases';
import { ProductService } from '@app/core/services';
import { takeUntil } from 'rxjs';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'app-product-detail-expeditions',
  imports: [ProductDetailInfosInput, ProgressSpinnerModule],
  templateUrl: './product-detail-expeditions.html'
})
export class ProductDetailExpeditions extends BaseComponent implements OnChanges {
  @Input() product!: Product;
  @Output() productChange: EventEmitter<Product> = new EventEmitter<Product>();

  @Input() tabStates!: TabStates[];
  @Output() tabStatesChange: EventEmitter<TabStates[]> = new EventEmitter<TabStates[]>();
  
  @Input() tabIndex!: number;

  isLoadingData: boolean = true;
  isSendingData: boolean = false;
  
  lineActivities: ProductLineEmitter[] = [];

  constructor(
    private productService: ProductService
  ) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tabStates']) {
      const tab: TabStates = this.tabStates.find(state => state.index === this.tabIndex) as TabStates
      if (tab.active && !tab.loaded) {
        this.getProductExpedition();
      }
    }
  }
  
  getProductExpedition(): void {
    this.apiCall$?.unsubscribe();
    this.apiCall$ = this.productService
      .get(this.product.id, {fields: {produits: 'longueur,largeur,hauteur,poids,numero_carton'}})
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          this.product = { ...this.product, ...data };
          this.tabStates.map((state: TabStates) => {
            if (state.index === this.tabIndex)
              state.loaded = true
          });
        },
        complete: () => {
          this.apiCall$?.unsubscribe();
          this.productChange.emit(this.product);
          this.isLoadingData = false;
        }
      });
  }
  
  sendingDataHandler(event: ProductLineEmitter) {
    const index = this.lineActivities.findIndex(line => line.property === event.property);
    if (index >= 0) this.lineActivities[index] = event;
    else this.lineActivities.push(event);

    if (event.message)
      this.toastService.add(event.message);

    this.productChange.emit(this.product);
  }

  isLineSendingData(): boolean {
    return this.lineActivities.some(line => line.isSendingData === true);
  }
}
